import type { StaticEquipment } from "../types/models";

const formatStaticEquipment = (staticEquipment?: Partial<StaticEquipment> | null) => {
  if (staticEquipment) {
    return `${staticEquipment.direction} ${staticEquipment.station_name} (${staticEquipment.type})`;
  } else {
    return "";
  }
};

export default formatStaticEquipment;
